<template>
    <app-layout title="Dashboard">
        <div class="py-6">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 space-y-8">
                <div>
                    <dl class="grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                        <div v-for="item in stats" :key="item.name" class="px-4 py-5 sm:p-6 text-center">
                            <div class="text-2xl font-semibold text-primary-500">
                                {{ item.stat }}
                            </div>
                            <dt class="text-base font-normal text-gray-900">
                                {{ __(item.name) }}
                            </dt>
                        </div>
                    </dl>
                </div>

                <ul role="list" class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" v-if="licenses.length >= 1">
                    <li v-for="license in licenses" :key="license.id" class="col-span-1 bg-white rounded-lg shadow divide-y divide-gray-200">
                        <inertia-link :href="route('license.show', {license: license})" class="w-full flex items-center justify-between p-6 space-x-6 cursor-pointer">
                            <div class="flex-1 truncate">
                                <div class="flex items-center space-x-3">
                                    <h3 class="text-gray-900 text-base font-medium truncate">{{ license.title }}</h3>
<!--                                    <span class="flex-shrink-0 inline-block px-2 py-0.5 text-green-800 text-xs font-medium bg-green-100 rounded-full">Extended</span>-->
                                </div>
<!--                                <p class="mt-1 text-gray-500 text-sm truncate">{{ person.title }}</p>-->
                            </div>
                            <div>
                                <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </div>
<!--                            <img class="w-10 h-10 bg-gray-300 rounded-full flex-shrink-0" :src="person.imageUrl" alt="" />-->
                        </inertia-link>
                        <div>
                            <div class="-mt-px flex divide-x divide-gray-200">
                                <div class="w-0 flex-1 flex">
                                    <a class="relative -mr-px w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-bl-lg hover:text-gray-500">
                                        <CubeIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                                        <span class="ml-3">{{ license.package.name }}</span>
                                    </a>
                                </div>
                                <div class="-ml-px w-0 flex-1 flex">
                                    <a class="relative w-0 flex-1 inline-flex items-center justify-center py-4 text-sm text-gray-700 font-medium border border-transparent rounded-br-lg hover:text-gray-500">
                                        <ClockIcon class="w-5 h-5 text-gray-400" aria-hidden="true" />
                                        <span class="ml-3">{{ date(license.expires_at) }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>

                <!-- Empty State / Placeholder for License List @TODO add href to order -->
                <inertia-link :href="route('order')" type="button" class="relative block w-full rounded-lg p-12 text-center focus:outline-none bg-white p-4" v-else>
                    <svg class="mx-auto h-12 w-12 text-gray-400" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" fill="none" viewBox="0 0 48 48" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v20c0 4.418 7.163 8 16 8 1.381 0 2.721-.087 4-.252M8 14c0 4.418 7.163 8 16 8s16-3.582 16-8M8 14c0-4.418 7.163-8 16-8s16 3.582 16 8m0 0v14m0-4c0 4.418-7.163 8-16 8S8 28.418 8 24m32 10v6m0 0v6m0-6h6m-6 0h-6" />
                    </svg>
                    <span class="mt-2 block text-sm font-medium text-gray-900">{{ __('Order new license') }}</span>
                </inertia-link>

            </div>
        </div>
    </app-layout>
</template>

<script>
    import { defineComponent } from 'vue'
    import AppLayout from '@/Layouts/AppLayout.vue'
    import { ArrowSmDownIcon, ArrowSmUpIcon, KeyIcon, PhoneIcon, MailIcon, ChevronRightIcon, CubeIcon, ClockIcon } from '@heroicons/vue/solid'
    import { CursorClickIcon, MailOpenIcon, UsersIcon } from '@heroicons/vue/outline'
    import Button from "@/Jetstream/Button";
    import PrimaryButton from "@/Jetstream/PrimaryButton";

    export default defineComponent({
        components: {
            PrimaryButton,
            Button,
            AppLayout,
            ArrowSmDownIcon,
            ArrowSmUpIcon,
            KeyIcon,
            PhoneIcon,
            MailIcon,
            ChevronRightIcon,
            CubeIcon,
            ClockIcon,
        },
        props: ['licenses'],
        data() {
            return {
                stats: [
                    { id: 1, name: 'Licenses', stat: this.licenses.length, icon: UsersIcon },
                    { id: 2, name: 'Avg. Open Rate', stat: '58.16%', icon: MailOpenIcon },
                    { id: 3, name: 'Avg. Click Rate', stat: '24.57%', icon: CursorClickIcon },
                ]
            }
        },
    })
</script>
